import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, regexValue: string, replaceValue: string): any {

    let regex = new RegExp(regexValue, 'g');
    try{
      if(value!==undefined) return value.replace(regex, replaceValue);

  }catch(error){
      console.log("error detectado",regex,replaceValue,value);
    }
  }


}
